exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".spotlight-search-result:hover {\n  background-color: #4f9efc; }\n  .spotlight-search-result:hover a {\n    text-decoration: none !important; }\n", ""]);

